import { signal } from '@preact/signals-react';

export const isLoadingExploreEnclosingComplexesSignal = signal<boolean>(false);

export const setIsLoadingExploreEnclosingComplexes = (isLoading: boolean) => {
    isLoadingExploreEnclosingComplexesSignal.value = isLoading;
};
